<template>
    <div class="flex flex-col items-center w-[100%] gap-5 mx-auto">
        <h3 class="font-Satisfy text-4xl text-red-500 text-center">{{ title }}</h3>
        <button @click="clickHandler"
            class="shadow-lg rounded-2xl hover:border-2 border-Primary  hover:-translate-y-1 hover:scale-105 duration-200 relative  w-64 h-64 ">
            <div class="flex items-center justify-center">
                <a :href="image" target="_blank">
                    <img v-if="!imgLoading" class="rounded-2xl object-cover object-center w-full h-full relative "
                        :src="image" alt="">
                </a>
                <div v-if="imgLoading">
                    <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem"
                        viewBox="0 0 24 24">
                        <defs>
                            <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                                <stop offset="0%" stop-color="#FFB908" />
                                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                            </linearGradient>
                            <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                                <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
                            </linearGradient>
                        </defs>
                        <g fill="none">
                            <path
                                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                            <path fill="url(#mingcuteLoadingFill0)"
                                d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                                transform="translate(1.5 1.625)" />
                            <path fill="url(#mingcuteLoadingFill1)"
                                d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                                transform="translate(1.5 1.625)" />
                        </g>
                    </svg>
                </div>
            </div>
        </button>
        <div class="text-center max-w-xs">
            <span ref="descRef" class="line-clamp-3 transition-all">
                {{ desc }}
            </span>
            <button v-if="isTruncated" @click="showModal = true" class="text-gray-400 text-sm mt-1 hover:underline">
                See More
            </button>
        </div>

        <!-- MODAL -->
        <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div class="bg-white rounded-lg p-5 border w-full max-w-4xl shadow-lg relative">
                <!-- Close button -->
                <div
                    class="flex justify-center items-center bg-black bg-opacity-50 rounded-full w-10 h-10 absolute -top-5 -right-5">
                    <button @click="showModal = false"
                        class="text-white text-center text-3xl z-50 hover:text-red-500 w-full h-full flex justify-center items-center">
                        &times;
                    </button>
                </div>

                <div class="flex flex-col items-center w-full gap-3 mx-auto">
                    <h3 class="font-Satisfy text-4xl text-red-500 text-center">{{ title }}</h3>
                    <div class="flex flex-col sm:flex-row justify-center gap-5 w-full">
                        <img :src="image" alt="Full Image"
                            class="w-full sm:w-1/2 object-cover shadow-lg rounded-2xl h-80" />
                        <div class="flex flex-col justify-between">
                            <div class="flex w-full">
                                <span
                                class="text-gray-700 p-2 text-center sm:text-left sm:p-4 overflow-y-auto sm:max-h-none max-h-36">
                                {{desc}}
                                </span>
                            </div>
                            <div class="flex w-full p-2 flex-nowrap flex-col gap-3">
                                <label class="text-left text-gray-500 text-sm">Want this product? <br />Message us on our social media accounts below:</label>
                                <div class="flex gap-3 justify-start">
                                    <a class="hover:-translate-y-1 duration-200" href="https://www.facebook.com/datesfruitphilippines" target="_blank">
                                        <img class="w-8 h-8" src="https://i.pinimg.com/originals/ce/d6/6e/ced66ecfc53814d71f8774789b55cc76.png" alt="">                    
                                    </a>
                                    <a class="hover:-translate-y-1 duration-200" href="https://www.instagram.com/datesfruitphilippines/" target="_blank">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><g fill="none"><rect width="256" height="256" fill="url(#skillIconsInstagram0)" rx="60"/><rect width="256" height="256" fill="url(#skillIconsInstagram1)" rx="60"/><path fill="#fff" d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396s-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413s.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5s6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355s22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334s-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"/><defs><radialGradient id="skillIconsInstagram0" cx="0" cy="0" r="1" gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse"><stop stop-color="#fd5"/><stop offset=".1" stop-color="#fd5"/><stop offset=".5" stop-color="#ff543e"/><stop offset="1" stop-color="#c837ab"/></radialGradient><radialGradient id="skillIconsInstagram1" cx="0" cy="0" r="1" gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771c8"/><stop offset=".128" stop-color="#3771c8"/><stop offset="1" stop-color="#60f" stop-opacity="0"/></radialGradient></defs></g>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
const props = defineProps({
    title: {
        type: String
    },
    desc: {
        type: String
    },
    image: {
        type: Number
    },
    gallery: {
        type: Array
    },
    imgLoading: {
        type: Boolean
    }
})

const showModal = ref(false);
const isTruncated = ref(false);
const descRef = ref(null);

const emit = defineEmits(['showGalleryClicked']);

function clickHandler(){
    emit('showGalleryClicked', props.gallery)

}

onMounted(async () => {
    await nextTick()
    if (descRef.value && descRef.value.scrollHeight > descRef.value.clientHeight) {
        isTruncated.value = true
    }
});

</script>

<style>

</style>